/* eslint-disable jsx-a11y/no-onchange */
import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { postPreferredTimes, postUpdateDefaultCalendar, removeCalendar } from '../../../api/api'
import CalendarsPopup from '../../../Components/calendar/popup/CalendarsPopup'
import { requestSettings } from '../../../store/settings/actions'
import { SettingsStore } from '../../../store/settings/types'
import { Plann3rStore } from '../../../store/types'
import { ApiResponse, Calendar } from '../../../types/plann3r'

import { Modal } from 'react-overlays'

import googleSignIn from '../../../assets/img/googleSignIn.jpg'
import icloud from '../../../assets/img/icloud.png'
import office365 from '../../../assets/img/office365.png'
import exchange from '../../../assets/img/exchange.jpg'
import Ranges from '../../../Components/ranges/Ranges'

const PreferencesTab: FC = () => {
  const [showModal, setshowModal] = useState(false)

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.settings.settings,
  )

  const { calendars, default_agenda, preferred_times } = useSelector(
    (state: Plann3rStore): SettingsStore => state.settings,
  )

  const dispatch = useDispatch()

  const toggleClose = () => {
    setshowModal(false)
  }

  const handleUpdateDefaultCalendarReceived = (response: ApiResponse) => {
    if (response.success) {
      dispatch(requestSettings())
    }
  }

  const updateDefaultCalendar = async (e: React.FocusEvent<HTMLSelectElement>) => {
    handleUpdateDefaultCalendarReceived(await postUpdateDefaultCalendar({
      agenda: e.target.value,
    }))
  }

  const renderCalendar = (calendar: Calendar) => {
    let url

    switch (calendar.name) {
      case 'Google':
        url = googleSignIn
        break
      case 'iCloud':
        url = icloud
        break
      case 'Office365':
      case 'Microsoft':
      case 'microsoft':
        url = office365
        break
      case 'Exchange':
        url = exchange
        break
      default:
        url = ''
        break
    }

    return (
      <li key={calendar.calendar_id}>
        <img src={url} style={{}} alt={calendar.name} />
        <span>{calendar.email}</span>
        <button
          className="button is-primary is-outlined ml-4"
          onClick={ async () => {
            const response: ApiResponse = await removeCalendar(calendar.calendar_id)

            if (response.success) {
              dispatch(requestSettings())
            } else {
              alert('Oops, something went wrong, please try again.')
            }
          }}
        >
          {strings.unlink}
        </button>
      </li>
    )
  }

  const modalStyle = {
    position: 'fixed',
    zIndex: 1040,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  }

  const backdropStyle = {
    ...modalStyle,
    zIndex: 'auto',
    backgroundColor: '#074981',
    opacity: 0.7,
  }

  return (
    <div>
      <div className="column preferences">
        <div className="columns">
          <div className="column is-6">
            <h3>{strings.calendars}</h3>
            <ul>{calendars.map(renderCalendar)}</ul>
            <br />
            <button
              className="button is-primary settingsButton"
              onClick={() => {
                setshowModal(true)
              }}
            >
              {strings.add_calendar}
            </button>
          </div>
          <div className="column is-6">
            <h3>{strings.primary_calendar}</h3>
            <p className="control">
              <span className="select">
                <select onChange={updateDefaultCalendar} value={default_agenda}>
                  <option value={0} key={0}>
                    {strings.no_primary_calendar}
                  </option>
                  {calendars.map((calendar) => (
                    <optgroup
                      key={calendar.calendar_id}
                      label={`${calendar.name}: ${calendar.email}`}
                    >
                      {calendar.agendas.map((agenda) => (
                        <option value={agenda.id} key={agenda.id}>
                          {agenda.agenda_name}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select>
              </span>
            </p>
            <Modal
              className="scrollModal"
              contentLabel={strings.calendar_popup_content_label}
              aria-labelledby="modal-label"
              style={modalStyle}
              backdropStyle={backdropStyle}
              show={showModal}
            >
              <CalendarsPopup
                title={strings.calendar_popup_title}
                text={strings.calendar_popup.text}
                button_text={strings.calendar_popup.button}
                next={toggleClose}
                toggleClose={toggleClose}
              />
            </Modal>
          </div>
        </div>
      </div>
      <div className="column preferences" />
      <hr />
      <div className="column">
        <h3>{strings.preferred_time}</h3>
        <Ranges ranges={preferred_times} save={(ranges) => postPreferredTimes({
          preferred_times: JSON.stringify(ranges),
        })} />
      </div>
    </div>
  )
}

export default PreferencesTab
